export enum ETextDecoration {
  NONE = 'none',
  UNDERLINE = 'underline',
}
